import events from '../../actions/event-names';
import Config from '../../config';
import { showError, showSuccess } from '../../utils';
import _ from 'lodash';

const initialState = {
    isListFetchCompleted: false,
    isListFetched: false,
    breathingRhythmList: [],
    isNewBreathingRhythmAdded: false,
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
 
    // BRATHINH RHYTHM LIST
    case `${events.GET_BREATHING_RHYTHM_LIST}_PENDING`: {
        if(action.meta.page === 0) {
            state.breathingRhythmList = [];
        }
        return {
            ...state,
            isListFetched: 'PENDING',
        };
    }
    case `${events.GET_BREATHING_RHYTHM_LIST}_FULFILLED`: {
        if(action.payload.data.length === 0) {
            state.isListFetchCompleted = true;
        }
        return {
            ...state,
            breathingRhythmList: [...state.breathingRhythmList, ...action.payload.data],
            isListFetched: 'FULFILLED',
        };
    }
    case `${events.GET_BREATHING_RHYTHM_LIST}_REJECTED`: {
        return {
            ...state,
            isListFetched: 'REJECTED',
        };
    }


    case `${events.ADD_NEW_BREATHING_RHYTHM}_PENDING`: {
        return {
            ...state,
            isNewBreathingRhythmAdded: 'PENDING',
        };
    }
    case `${events.ADD_NEW_BREATHING_RHYTHM}_FULFILLED`: {
        showSuccess("New breathing rhythm successfully")
        return {
            ...state,
            isNewBreathingRhythmAdded: 'FULFILLED',
        };
    }
    case `${events.ADD_NEW_BREATHING_RHYTHM}_REJECTED`: {
        showError("An error occured, Please refresh and try again")
        return {
            ...state,
            isNewBreathingRhythmAdded: 'REJECTED',
        };
    }



    case `${events.GET_BREATHING_DETAILS}_PENDING`: {
        return {
            ...state,
            brDetails: "",
            isDetailsFetched: 'PENDING',
        };
    }
    case `${events.GET_BREATHING_DETAILS}_FULFILLED`: {
        return {
            ...state,
            brDetails: action.payload.data,
            isDetailsFetched: 'FULFILLED',
        };
    }
    case `${events.GET_BREATHING_DETAILS}_REJECTED`: {
        return {
            ...state,
            isDetailsFetched: 'REJECTED',
        };
    }


    case `${events.SAVE_BR_DETAILS}_PENDING`: {
        return {
            ...state,
            isDetailsUpdated: 'PENDING',
        };
    }
    case `${events.SAVE_BR_DETAILS}_FULFILLED`: {
        showSuccess("New breathing rhythm updated successfully")
        return {
            ...state,
            isDetailsUpdated: 'FULFILLED',
        };
    }
    case `${events.SAVE_BR_DETAILS}_REJECTED`: {
        showError("An error occured, Please refresh and try again")
        return {
            ...state,
            isDetailsUpdated: 'REJECTED',
        };
    }


    case `${events.DELETE_BREATHING_RHYTHM}_PENDING`: {
        return {
            ...state,
            isDeletedSuccessfully: 'PENDING',
        };
    }
    case `${events.DELETE_BREATHING_RHYTHM}_FULFILLED`: {
        showSuccess("Deleted successfully")
        return {
            ...state,
            isDeletedSuccessfully: 'FULFILLED',
        };
    }
    case `${events.DELETE_BREATHING_RHYTHM}_REJECTED`: {
        showError("An error occured, Please refresh and try again")
        return {
            ...state,
            isDeletedSuccessfully: 'REJECTED',
        };
    }
    

    default:
        return state;
    }
}
